<template>
  <div>
<section v-if="!campaign.type">
    <h4 class="card-title" v-if="isStaticPosition"><i class="fa fa-exclamation-circle"></i> Step 1</h4>
    <blockquote>
      This is the JavaScript code for this widget. Copy and paste this code before <b>&lt;/BODY&gt;</b> tag of every web page that you want to show widget on. 
    </blockquote>
    <div>
      <b-form-textarea
        id="widget-code"
        :value="widgetCode"
        @click.native.prevent="$event.target.select()"
        :rows="10"
        :max-rows="12">
      </b-form-textarea>
    </div>
    <div v-if="isStaticPosition">
      <h4 class="card-title mt-3"><i class="fa fa-exclamation-circle"></i> Step 2</h4>
      <blockquote>
        Insert the following tag on your web page where you want the widget to appear.
      </blockquote>
      <div v-if="isStaticPosition">
        <code>&lt;div id=&quot;nextlead-widget&quot;&gt;&lt;/div&gt;</code>
      </div>
    </div>
  </section>
  <section v-if="campaign.type === 'shopify'">
    <h4 class="card-title"><i class="fa fa-exclamation-circle"></i> Step 1</h4>
    <blockquote>
      This is the JavaScript code for this widget. Copy and paste this code before <b>&lt;/BODY&gt;</b> tag of every web page that you want to show widget on. 
    </blockquote>
    <div>
      <b-form-textarea
        id="widget-code"
        :value="widgetCodeShopify"
        @click.native.prevent="$event.target.select()"
        :rows="10"
        :max-rows="12">
      </b-form-textarea>
    </div>
    <div>
      <h4 class="card-title mt-3"><i class="fa fa-exclamation-circle"></i> Step 2</h4>
      <blockquote>
        Add the <strong>'nextlead-product'</strong> attribute on your web page element where you want the widget to appear.
      </blockquote>
      <div>
        <code>&lt;section nextlead-product=&quot;{product id}&quot;&gt;...&lt;/section&gt;</code>
      </div>
    </div>
  </section>
  </div>
</template>
<script>
import { getWidgetCode, getShopifyWidgetCode } from '@/helpers/widget';
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters(['campaign']),
    widget() {
      return this.campaign.widget || {}
    },
    widgetCode() {
      return getWidgetCode(this.campaign.id);
    },
    widgetCodeShopify() {
      return getShopifyWidgetCode(this.campaign.id);
    },
    isStaticPosition() {
      return this.widget && this.widget.position === 'static';
    }
  }
};
</script>
<style scoped>
  #widget-code {
    font-size: 12px;
    font-family: 'Courier New', Courier, monospace;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Campaigns/Details/WidgetCode.vue